// extracted by mini-css-extract-plugin
export default {"addToCartControl":"M1-z","giftCard":"N1-z","btnContainer":"O1-z","cartButton":"P1-z","disabled":"Q1-z"};